module.exports = __webpack_public_path__ + "static/media/p_24_2.e4ca7378.png";